var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgThreadslogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0786 21.9346C19.2288 22.1036 18.2869 23.4802 18.3593 24.712C18.4559 26.3784 20.2431 27.1513 21.982 27.0547C23.6726 26.958 25.6047 26.306 25.9429 22.2002C25.0734 22.007 24.0832 21.9104 23.0688 21.9104C22.7066 21.9104 22.3926 21.9104 22.0786 21.9346Z",
    fill: "url(#paint0_linear_750_6043)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4745 3H11.5013C6.81593 3 3 6.81593 3 11.5013V31.4987C3 36.1841 6.81593 40 11.5013 40H31.4987C36.1841 40 40 36.1841 40 31.4987V11.5013C39.9758 6.81593 36.1841 3 31.4745 3ZM13.2161 31.0157C15.0757 33.3825 17.9497 34.5901 21.7415 34.6142C25.1469 34.5901 27.4171 33.7689 29.3009 31.9093C31.4504 29.7598 31.4021 27.1273 30.7259 25.5333C30.3153 24.5914 29.5907 23.8185 28.6005 23.2148C28.359 25.002 27.8277 26.4269 26.9582 27.5137C25.8231 28.9628 24.205 29.7356 22.1279 29.8564C20.5581 29.953 19.0607 29.5666 17.8773 28.7937C16.5007 27.876 15.6795 26.4752 15.6071 24.8571C15.438 21.6449 17.9739 19.3505 21.9347 19.109C23.3355 19.0366 24.6638 19.0849 25.8714 19.3022C25.7024 18.312 25.3884 17.5392 24.9054 16.9595C24.2291 16.1867 23.2148 15.7761 21.8381 15.7761C21.814 15.7761 21.814 15.7761 21.7898 15.7761C20.6547 15.8003 19.1815 16.0901 18.2154 17.5392L15.921 15.9693C17.201 14.0372 19.2539 12.9745 21.7415 12.9745C21.7657 12.9745 21.7898 12.9745 21.7898 12.9745C25.9439 12.9987 28.4315 15.6071 28.673 20.1234C28.8179 20.1958 28.9628 20.2441 29.0836 20.3166C31.0157 21.2585 32.4406 22.6593 33.1893 24.3982C34.2278 26.8133 34.3244 30.75 31.1847 33.9138C28.7696 36.329 25.8473 37.3916 21.7174 37.44H21.6932C17.032 37.4158 13.4576 35.846 11.0424 32.7787C8.89295 30.0496 7.78198 26.2578 7.75783 21.5242C7.80614 16.7663 8.89295 12.9745 11.0424 10.2696C13.4576 7.20235 17.032 5.63251 21.6932 5.60836H21.7174C26.3786 5.63251 30.0255 7.20235 32.4889 10.2454C33.7206 11.7428 34.6142 13.5542 35.1939 15.6795L32.5131 16.404C32.03 14.6893 31.3296 13.2161 30.3877 12.0568C28.4556 9.68995 25.5333 8.45822 21.7174 8.43407C17.9497 8.38577 15.0757 9.61749 13.2161 11.9843C11.4772 14.2063 10.5594 17.3943 10.5352 21.5C10.5594 25.5816 11.4772 28.7937 13.2161 31.0157Z",
    fill: "url(#paint1_linear_750_6043)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_750_6043",
    x1: 10.5172,
    y1: 1.42644,
    x2: 31.8912,
    y2: 42.3631,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#515BD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#8134AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DD2A7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#F58529"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEDA77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_750_6043",
    x1: 10.9086,
    y1: 1.22277,
    x2: 32.2826,
    y2: 42.1595,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#515BD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#8134AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DD2A7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#F58529"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEDA77"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreadslogo);
export default __webpack_public_path__ + "static/media/threadslogo.a84f1f2739834019aa1665b45040e892.svg";
export { ForwardRef as ReactComponent };